"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const react_1 = tslib_1.__importDefault(require("react"));
const TablePagination_1 = tslib_1.__importDefault(require("@mui/material/TablePagination"));
const Skeleton_1 = tslib_1.__importDefault(require("@mui/material/Skeleton"));
const TablePaginationActions_1 = tslib_1.__importDefault(require("./TablePaginationActions"));
// Hack to cast the TablePagination component to desired type
const MuiTablePagination = TablePagination_1.default;
/**
 * Table pagination component that embodies the Argus standard for pagination
 *
 * @example
 *
 * Basic example showing the TablePagination
 *
 * ```jsx live noInline
 * file://./__examples__/1_BasicTablePagination.jsx
 * ```
 */
const TablePagination = (props) => {
    const { loading, component, ...restProps } = props;
    const labelDisplayedRows = loading
        ? () => react_1.default.createElement(Skeleton_1.default, { variant: "rectangular", height: 26, width: 55 })
        : props.labelDisplayedRows;
    return (react_1.default.createElement(MuiTablePagination, { ...restProps, component: component, labelDisplayedRows: labelDisplayedRows, SelectProps: { ...props.SelectProps, disabled: loading }, ActionsComponent: TablePaginationActions_1.default }));
};
exports.default = TablePagination;
